exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-flexContainer-3qqr8 {\n  display: flex;\n  position: fixed;\n  top: 80px;\n  width: 100%;\n}\n\n.content-sideBar-pNT9I {\n  height: 600px;\n  overflow: auto;\n  width: 450px;\n}\n\n.content-main-2-eLa {\n  height: 600px;\n  position: relative;\n  width: calc(100% - 450px);\n}\n\n.content-map-359bc {\n  height: calc(100% - 40px);\n  width: 100%;\n}\n\n.content-genres-1TWUQ {\n  height: 40px;\n  width: 100%;\n  position: relative;\n}\n", ""]);

// exports
exports.locals = {
	"sideBarWidth": "450px",
	"contentHeight": "600px",
	"genresHeight": "40px",
	"flexContainer": "content-flexContainer-3qqr8",
	"sideBar": "content-sideBar-pNT9I",
	"main": "content-main-2-eLa",
	"map": "content-map-359bc",
	"genres": "content-genres-1TWUQ"
};